import { NgModule } from '@angular/core';
import { DailyTasksComponent } from './daily-tasks/daily-tasks.component';
import { PspRoutingModule } from './psp-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { PendingCarereceiverComponent } from './pending-carereceiver/pending-carereceiver.component';
import { AddingCaregiverComponent } from './adding-caregiver/adding-caregiver.component';
import { FetchUserDataModalComponent } from './fetch-user-data-modal/fetch-user-data-modal.component';
import { ChooseCustomerModalComponent } from './choose-customer-modal/choose-customer-modal.component';
import { AddPatientComponent } from './add-patient/add-patient.component';
import { PendingPatientComponent } from './pending-patient/pending-patient.component';
import { HomeDeliveryComponent } from './medication-requests/home-delivery/home-delivery.component';
import { PickUpComponent } from './medication-requests/pick-up/pick-up.component';
import { SelectPharamcyComponent } from './medication-requests/select-pharamcy/select-pharamcy.component';
import { NearestPharmacyModalComponent } from './nearest-pharmacy-modal/nearest-pharmacy-modal.component';
import { RequestDetailsComponent } from './medication-requests/request-details/request-details.component';
import { FormsModule } from '@angular/forms';
import { PharmaciesComponent } from './pharmacies/pharmacies.component';
import { AddStockModalComponent } from './add-stock-modal/add-stock-modal.component';
import { PharmacyDetailsComponent } from './pharmacy-details/pharmacy-details.component';
import { CancelRequestModalComponent } from './medication-requests/cancel-request-modal/cancel-request-modal.component';
import { FinglodineSubscriptionsComponent } from './finglodine-subscriptions/finglodine-subscriptions.component';
import { PspPatientsComponent } from './psp-patients/psp-patients.component';
import { CompaniesSelectComponent } from '@components/companies-select/companies-select.component';
import { AppUploadFileComponent } from '@components/app-upload-file/app-upload-file.component';
import { PreviewDocumentsModalComponent } from '@components/preview-documents-modal/preview-documents-modal.component';
import { MyJourneyBeyondWeightComponent } from './my-journey-beyond-weight/my-journey-beyond-weight.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TabViewModule } from 'primeng/tabview';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputNumberModule } from 'primeng/inputnumber';
import { MessageModule } from 'primeng/message';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { FileUploadModule } from 'primeng/fileupload';
import { GalleriaModule } from 'primeng/galleria';
import { PaginatorModule } from 'primeng/paginator';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { BadgeModule } from 'primeng/badge';
import { AddRochePatientComponent } from './add-roche-patient/add-roche-patient.component';
import { MedicationDosageFormComponent } from '@components/medication-dosage-form/medication-dosage-form.component';

@NgModule({
  imports: [
    PspRoutingModule,
    SharedModule,
    FormsModule,
    BsDatepickerModule.forRoot(),

    TabViewModule,
    TableModule,
    DropdownModule,
    MultiSelectModule,
    InputNumberModule,
    MessageModule,
    CalendarModule,
    DialogModule,
    InputTextModule,
    ButtonModule,
    DividerModule,
    FileUploadModule,
    GalleriaModule,
    PaginatorModule,
    InputTextareaModule,
    ConfirmDialogModule,
    BadgeModule,
    MedicationDosageFormComponent,
  ],
  declarations: [
    DailyTasksComponent,
    PendingCarereceiverComponent,
    AddingCaregiverComponent,
    FetchUserDataModalComponent,
    ChooseCustomerModalComponent,
    AddPatientComponent,
    PendingPatientComponent,
    HomeDeliveryComponent,
    PickUpComponent,
    SelectPharamcyComponent,
    NearestPharmacyModalComponent,
    RequestDetailsComponent,
    PharmaciesComponent,
    PharmacyDetailsComponent,
    AddStockModalComponent,
    CancelRequestModalComponent,
    FinglodineSubscriptionsComponent,
    PspPatientsComponent,
    CompaniesSelectComponent,
    AppUploadFileComponent,
    PreviewDocumentsModalComponent,
    MyJourneyBeyondWeightComponent,
    AddRochePatientComponent,
  ],
  exports: [AppUploadFileComponent],
})
export class PspModule {}
